import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { ParticlesProvider } from '@tsparticles/react';
import { loadSlim } from '@tsparticles/slim';
import './index.css';
import App from './App';
import { store, persistor } from './redux/store/store';
import reportWebVitals from './reportWebVitals';

const particlesInit = async (engine) => {
  await loadSlim(engine);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ParticlesProvider init={particlesInit}>
          <App />
        </ParticlesProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// if (window) {
//   window.console.log = () => {};
//   window.console.error = () => {};
//   window.console.warn = () => {};
// }

reportWebVitals();